import requestConfig, {
  request as requestSdk,
  storeRequest as storeRequestSdk,
} from '@tencent/eyao-request-web-sdk';
import config from '@/config';
import aegis from '@/plugins/aegis';
import login from '@/utils/login';

requestConfig({
  product: config.apiProduct,
  platform: config.apiPlatform,
  aegis,
  whiteFilter: config.whiteFilter,
  apiList: config.apiList,
  cloud: config.cloud,
  api: config.api,
  expireLogin: () => {
    login.clearLogin();
    login.toLogin();
  },
});
function setToken(cmd) {
  const token = login.getToken();
  const uin = login.getUin();
  if (!token && !config.whiteFilter.includes(cmd)) {
    login.toLogin();
    return false;
  }
  aegis.setConfig({
    uin,
  });
  requestConfig({
    token,
  });
  return true;
}
function setErr(e) {
  if (e && e.bizcode && [2403, 2404, 2405].includes(e.bizcode)) {
    // 没有权限
    window.Vue && window.Vue.prototype.$message('权限不足，请联系管理员');
  }
}
const request = function (cmd, payload = {}, options) {
  if (!setToken(cmd)) return Promise.reject(new Error('登陆后，访问系统'));
  return requestSdk(cmd, payload, options).catch((e) => {
    setErr(e);
    return Promise.reject(e);
  });
};

const storeRequest = function (opt, options) {
  if (!setToken(opt.cmd)) return Promise.reject(new Error('登陆后，访问系统'));
  return storeRequestSdk(opt, options).catch((e) => {
    setErr(e);
    return Promise.reject(e);
  });
};

export { request, storeRequest };
export default request;
